import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => {
  return {
    listItem: {
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
    },
    optionText: {
      '& > span': {
        maxWidth: '86%',
      },
    },
    menuItemButton: {
      gap: 1,
    },
  };
});

export default useStyles;
